var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuliFamilies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 29.999,
    viewBox: "0 0 30 29.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4840",
    "data-name": "Rectangle 4840",
    width: 30,
    height: 29.999,
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10128",
    "data-name": "Group 10128",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10127",
    "data-name": "Group 10127",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5686",
    "data-name": "Path 5686",
    d: "M10.969,12a.493.493,0,0,1,.529.5V14a.5.5,0,0,1-1,0l0-1h-4v7.988a.525.525,0,0,1,.5.486A.494.494,0,0,1,6.5,22h-4v1l3.122,0a.484.484,0,0,1,.485.52A.507.507,0,0,1,5.564,24L2,24a.49.49,0,0,1-.5-.5v-2A.49.49,0,0,1,2,21l1-.006v-9.9l-.767.581a.5.5,0,0,1-.714-.068L.118,9.823a.5.5,0,0,1,.071-.711L11.215.477A1.987,1.987,0,0,1,13.709.425l3.285,2.559L17,.5a.493.493,0,0,1,.5-.5h4a.513.513,0,0,1,.5.567V6.911l2.817,2.205a.5.5,0,0,1,.066.706l-1.4,1.784a.484.484,0,0,1-.673.09l-.8-.613L22,14a.5.5,0,0,1-1,0l-.009-3.72L12.5,3.635,4,10.285V21l1.5,0V12.507A.489.489,0,0,1,6,12Zm1.922-9.332,10.116,7.918.787-1L13.073,1.2a.966.966,0,0,0-1.109-.029L1.215,9.578,2,10.586,12.17,2.624a.522.522,0,0,1,.721.044m8.1,3.43L21,1H18l.006,2.787Z",
    transform: "translate(0 0)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5687",
    "data-name": "Path 5687",
    d: "M21.1,24.022A1.992,1.992,0,0,0,19.1,22h-4A1.99,1.99,0,0,0,13.1,24l0,2.5a.5.5,0,0,1-1,0l0-2.5a3.019,3.019,0,0,1,2.771-2.992A3.023,3.023,0,0,1,14.1,19H9.039a2.473,2.473,0,0,0-2.427,2.44L6.6,26.5a.5.5,0,1,1-1,0l0-4.933a3.53,3.53,0,0,1,3.542-3.575,3.5,3.5,0,1,1,5.565-.84,3.063,3.063,0,0,1,4.789,0,3.537,3.537,0,0,1,1.164-4.566,3.5,3.5,0,0,1,4.4,5.407A3.507,3.507,0,0,1,28.6,21.5l0,5a.5.5,0,0,1-.47.5.49.49,0,0,1-.526-.5l-.014-5.059A2.471,2.471,0,0,0,25.224,19L20.1,19a3.035,3.035,0,0,1-.769,2.007A3.014,3.014,0,0,1,22.1,24l0,2.5a.5.5,0,0,1-1,0Zm-9.815-11a2.5,2.5,0,1,0,2.791,2.157,2.487,2.487,0,0,0-2.791-2.157m11,0a2.5,2.5,0,1,0,2.791,2.157,2.489,2.489,0,0,0-2.791-2.157m-5.5,4a2,2,0,1,0,2.286,1.655,1.989,1.989,0,0,0-2.286-1.655",
    transform: "translate(1.4 2.999)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5688",
    "data-name": "Path 5688",
    d: "M15.367,14.1l.534-.01V10.6H11.408l-.009.44a.5.5,0,0,1-.47.559.494.494,0,0,1-.528-.5V10.1a.489.489,0,0,1,.5-.5H16.4a.492.492,0,0,1,.5.5v4.5a.492.492,0,0,1-.5.5h-1a.49.49,0,0,1-.5-.47.479.479,0,0,1,.465-.525",
    transform: "translate(2.601 2.4)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M8.6,24.27a.5.5,0,0,1-.474.527.494.494,0,0,1-.526-.5v-3a.5.5,0,1,1,1,0Z",
    transform: "translate(1.901 5.2)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5690",
    "data-name": "Path 5690",
    d: "M22.2,24.27a.5.5,0,0,1-.472.527.494.494,0,0,1-.528-.5v-3a.5.5,0,1,1,1,0Z",
    transform: "translate(5.3 5.2)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5691",
    "data-name": "Path 5691",
    d: "M13.4,24.072a.5.5,0,0,1-.53.526.515.515,0,0,1-.475-.559L12.4,22.1a.494.494,0,0,1,.527-.5.515.515,0,0,1,.475.56Z",
    transform: "translate(3.099 5.4)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5692",
    "data-name": "Path 5692",
    d: "M17.4,24.072a.5.5,0,0,1-.53.526.515.515,0,0,1-.475-.559l0-1.941a.494.494,0,0,1,.528-.5.516.516,0,0,1,.475.56Z",
    transform: "translate(4.099 5.4)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuliFamilies);
export default __webpack_public_path__ + "static/media/buli_families.edf3eda8267c75e8c1b95f3f4d90cc56.svg";
export { ForwardRef as ReactComponent };